module.exports = __webpack_public_path__ + "static/media/Insert-Lid.df7d0f84.svg";